import { FC } from 'react';
import { CalendarViewType, ViewMode } from '../utils/enums';

interface CalendarViewTypeSelectorProps {
  viewType: CalendarViewType;
  currentView: ViewMode;
  onViewChange: (view: ViewMode) => void;
}

export const CalendarViewTypeSelector: FC<CalendarViewTypeSelectorProps> = ({
  viewType,
  currentView,
  onViewChange,
}) => {
  const calendarViewOptions = [
    { label: 'Day', value: ViewMode.TIME_GRID_DAY },
    { label: 'Week', value: ViewMode.TIME_GRID_WEEK },
    { label: 'Month', value: ViewMode.DAY_GRID_MONTH },
  ];

  const resourceViewOptions = [
    { label: 'Day', value: ViewMode.RESOURCE_TIME_GRID_DAY },
    { label: 'Month', value: ViewMode.RESOURCE_TIMELINE_MONTH },
  ];

  const viewOptions =
    viewType === CalendarViewType.CALENDARS
      ? calendarViewOptions
      : resourceViewOptions;

  return (
    <div className="flex space-x-1 rounded-xl bg-neutral-50 p-1">
      {viewOptions.map((option) => (
        <button
          key={option.value}
          className={`text-sm rounded-lg px-3 py-1 font-medium focus:outline-none focus:ring-2 focus:ring-secondary-50 ${
            currentView === option.value
              ? 'bg-white text-green-150 shadow'
              : 'text-neutral-125 hover:text-green-150'
          }`}
          onClick={() => onViewChange(option.value)}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
};
